import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { loadFirebaseCredentials } from './firebaseConfigLoader.js';

const firebaseCredentials = loadFirebaseCredentials();
const firebaseApp = initializeApp(firebaseCredentials);

export default getMessaging(firebaseApp);
